module.exports = __webpack_public_path__ + "img/dna-report.242f7d4.png";